export default __webpack_public_path__ + "static/media/ballon404.70147cf5.png";